/**
 * An image the editor's markup references could not be fetched, so the markup
 * can't be rasterized or persisted. The common cause is markup carrying an
 * expired presigned URL instead of an `image:` ref, which no longer resolves.
 *
 * The message deliberately avoids the substring "Failed to fetch": monitoring
 * filters it (`FILTERED_ERROR_MESSAGES` in src/lib/monitoring), so phrasing it
 * that way drops the report before it reaches Sentry.
 */
export class UnreachableImageAssetError extends Error {
  override readonly name = "UnreachableImageAssetError";

  constructor(public readonly url: string) {
    super(`Image asset could not be loaded: ${url}`);
  }
}
